import React from 'react';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Table, Icon, Popconfirm } from 'antd';
import PropTypes from 'prop-types';
import { Permission } from 'components/page/index';
import PERMISSIONS from 'config/app-permission.config';
import EmailTemplateModal from './EmailTemplateModal';
import { fetchTemplateData, queryByPaging, deleteTemplate } from '../../flow/action';

const defaultProps = {};

const propTypes = {
  templates: PropTypes.array.isRequired,
  isSharedByVisible: PropTypes.bool.isRequired,
  isCurrentUser: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.bool
  ]).isRequired,
  templatesDataTablePagination: PropTypes.object.isRequired,
  selectedFolder: PropTypes.object.isRequired,
  editTemplate: PropTypes.object.isRequired,
};

class TemplatesTable extends React.Component {
  constructor() {
    super();
    this.state = { visible: false };
  }

  componentDidMount() {
    const {
      templatesDataTablePagination,
      selectedFolder,
      dispatchQueryByPaging
    } = this.props;

    if (selectedFolder.id) {
      dispatchQueryByPaging({
        perPage: templatesDataTablePagination.perPage,
        currentPage: templatesDataTablePagination.currentPage,
        folderId: selectedFolder.id
      });
    }
  }

  showModal = () => this.setState({ visible: true })

  handleModalClose = () => this.setState({ visible: false });

  render() {
    const {
      templates,
      intl,
      isSharedByVisible,
      isCurrentUser,
      history,
      templatesDataTablePagination,
      selectedFolder,
      editTemplate,
      dispatchFetchTemplateData,
      dispatchQueryByPaging,
      dispatchDeleteTemplate
    } = this.props;
    const { visible } = this.state;
    const { formatMessage } = intl;
    const {
      currentPage,
      perPage,
      total,
    } = templatesDataTablePagination;

    const pagination = {
      defaultCurrent: currentPage,
      current: currentPage,
      defaultPageSize: perPage,
      pageSize: perPage,
      total,
      size: 'small',
      onChange: (page, pageSize) => {
        dispatchQueryByPaging({ perPage: pageSize, currentPage: page, folderId: selectedFolder.id });
      }
    };

    const columns = [
      {
        key: 'id',
        render: record => (
          <span>
            {isCurrentUser() && !isSharedByVisible &&
              <Permission permission={PERMISSIONS.SETUP_EMAILCOMMUNICATIONS_EMAILTEMPLATES_UPDATE}>
                <Icon
                  type="edit"
                  onClick={() => {
                    dispatchFetchTemplateData({
                        templateId: record.id,
                        cb: history.push(`template-edit/${record.id}`)
                    });
                  }}
                />
              </Permission>
            }
            {(isCurrentUser() && isSharedByVisible) &&
              <Permission permission={PERMISSIONS.SETUP_EMAILCOMMUNICATIONS_EMAILTEMPLATES_VIEW}>
                <Icon
                  type="eye-o"
                  className="cursor-pointer"
                  onClick={() => {
                    dispatchFetchTemplateData({
                        templateId: record.id,
                        cb: () => this.showModal(),
                    });
                  }}
                />
              </Permission>
            }
            {isCurrentUser() && !isSharedByVisible &&
              <Permission permission={PERMISSIONS.SETUP_EMAILCOMMUNICATIONS_EMAILTEMPLATES_DELETE}>
                <Popconfirm
                  title={formatMessage({ id: 'global.ui.dialog.deleteTitle' })}
                  onConfirm={() =>
                    dispatchDeleteTemplate({
                      templateId: record.id,
                      folderId: selectedFolder.id
                  })}
                >
                  <Icon type="delete" className="danger pl-lg" />
                </Popconfirm>
              </Permission>
            }
          </span>
        )
      },
      {
        title: formatMessage({ id: 'page.emailTemplates.templateName' }),
        dataIndex: 'name',
        key: 'name'
      },
      {
        title: formatMessage({ id: 'page.emailTemplates.createdDate' }),
        dataIndex: 'created_at',
        key: 'created_at'
      },
      {
        title: formatMessage({ id: 'page.emailTemplates.templateModifiedDate' }),
        dataIndex: 'updated_at'
      },
      {
        title: formatMessage({ id: 'page.emailTemplates.createdBy' }),
        dataIndex: 'folder_created_by_user.name'
      },
      {
        title: formatMessage({ id: 'page.emailTemplates.templateDescription' }),
        dataIndex: 'description'
      }
    ];
    return (
      <React.Fragment>
        <EmailTemplateModal
          editTemplate={editTemplate}
          visible={visible}
          handleModalClose={this.handleModalClose}
        />
        <Table
          dataSource={selectedFolder.id ? templates : []}
          columns={columns}
          pagination={pagination}
          rowKey="id"
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ setup }) => ({
  templates: setup.emailTemplates.templates.templates,
  templatesDataTablePagination: setup.emailTemplates.templatesDataTablePagination,
  selectedFolder: setup.emailTemplates.selectedFolder,
  editTemplate: setup.emailTemplates.editTemplate
});
const mapDispatchToProps = {
  dispatchFetchTemplateData: fetchTemplateData,
  dispatchQueryByPaging: queryByPaging,
  dispatchDeleteTemplate: deleteTemplate,
};

TemplatesTable.propTypes = propTypes;
TemplatesTable.defaultProps = defaultProps;

const Enhancer = compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  injectIntl
);

export default Enhancer(TemplatesTable);



// WEBPACK FOOTER //
// ./src/views/email/emailTemplates/component/templateDetailComponent/TemplatesTable.jsx